import * as React from 'react';
import {
  DialogProps,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  Button,
} from '@material-ui/core';
import { useStyles } from './styles';
import { useFetch } from 'hooks';
import { DelayedLinearProgress, SnackbarContext } from 'components';
import { FtpConfig } from 'lib/Model/FtpConfig';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { format, isBefore, startOfDay, subMonths } from 'date-fns';

interface Props extends DialogProps {
  ftpConfig: FtpConfig;
}

export const SyncClockingsDialog: React.FC<Props> = ({
  ftpConfig,
  ...rest
}) => {
  const classes = useStyles();
  const [forceFromDate, setForceFromDate] = React.useState<Date | undefined>();
  const snackbar = React.useContext(SnackbarContext);

  const { loading: saveLoading, sendRequest } = useFetch();
  const minDate = React.useMemo(
    () => startOfDay(subMonths(new Date(), 12)),
    [],
  );

  return (
    <Dialog maxWidth="md" fullWidth {...rest}>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (forceFromDate && isBefore(forceFromDate, minDate)) {
            snackbar.error(
              `Minimum allowed date for sync is ${format(
                minDate,
                'yyyy-MM-dd',
              )}`,
            );
            return;
          }

          const response = await sendRequest(
            `api/ftp-configs/${ftpConfig.id}/run-push`,
            {
              postData: {
                forceFromDate: forceFromDate
                  ? format(forceFromDate, 'yyyy-MM-dd')
                  : undefined,
              },
            },
          );
          const jsonResponse = await response.json();
          if (jsonResponse) {
            snackbar.success(`Upload complete`);
          } else {
            snackbar.error(`Upload failed or nothing to upload.`);
          }
          rest && rest.onClose && rest.onClose(e, 'escapeKeyDown');
        }}
      >
        <DialogTitle>Upload clockings now</DialogTitle>
        <DialogContent>
          <DelayedLinearProgress loading={saveLoading} />
          <Grid container>
            <Grid item md={12}>
              <FormControl className={classes.formControl} fullWidth>
                <KeyboardDatePicker
                  label="Date from"
                  helperText="Leave this empty to use the default sync - which syncs all data since the last time it synchronised"
                  placeholder="dd/MM/yyyy"
                  format="dd/MM/yyyy"
                  autoFocus
                  onChange={(date) => setForceFromDate(date || undefined)}
                  minDate={minDate}
                  value={forceFromDate || null}
                  fullWidth
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) =>
              rest && rest.onClose && rest.onClose(e, 'escapeKeyDown')
            }
          >
            Close
          </Button>
          <Button color="primary" type="submit">
            Run upload now
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
